export class RequisitionStepHistoryEmitter {
	requisitionId: number;
	requisitionStepHistoryId: number;
	actionType: string;

	constructor() {
		this.requisitionId = -1;
		this.requisitionStepHistoryId = -1;
		this.actionType = "";
	}
}
